<template>
  <div>
    <footer>
      <div class="footer-top">
        <div class="top-con">
          <div class="footer-left">
            <div class="site">
              <div class="item" style="width: 55%;margin-right:4%">
                <div class="item-tit">联系我们</div>
                <div class="item-con">
                  <table class="list">
                    <tr>
                      <td>咨询热线</td>
                      <td>17200371784</td>
                    </tr>
                    <tr>
                      <td>
                        企业邮箱
                      </td>
                      <td>
                        ljl@bjthinkpower.com
                      </td>
                    </tr>
                    <tr>
                      <td>
                        运营中心
                      </td>
                      <td @click="gotoMap('baidu-map-container')">
                        <p style="cursor:pointer;line-height:30px"> 沈阳铁西区工业互联网创新大厦
                          中德企业创新孵化中心C座
                        </p>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <div class="item guanzhu" style="width: 39%;">
                <div class="item-tit">关注我们</div>
                <div class="item-con">
                  <div>
                    <img class="erweima" :src="erweima">
                    <p>公众号</p>
                  </div>
                  <div>
                    <img class="erweima" :src="qywx">
                    <p>企业微信</p>
                  </div>
                  <div>
                    <img class="erweima" :src="dy">
                    <p>抖音</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-right">
            <div id="baidu-map-container" @click="openDialog" style="width: 100%; height: 172px;margin-bottom:30px"></div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="copyright">
          <!-- CopyRight@2018 ZHONGNENGHANGKE ALL RIGHTS RESERVERD 中能航科科技（北京）有限公司 版权所有 -->
          <a href="https://beian.miit.gov.cn" target="_blank"> 备案号: 京ICP备2024043687号-1</a>
        </div>
      </div>
    </footer>
    <el-dialog title="地理位置" :visible.sync="showDialog" width="40%">
      <p @click="gotoMap('baidu-map-container2')" style="cursor:pointer;margin-bottom:20px"> 沈阳铁西区工业互联网创新大厦
        中德企业创新孵化中心C座
      </p>
      <div id="baidu-map-container2" style="width: 100%; height: 450px"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Head',
  components: {

    // import引入的组件需要注入到对象中才能使用
  },
  data() {
    return {
      erweima: require("@/assets/img/erweima.png"),
      qywx: require("@/assets/img/qywx.png"),
      dy: require("@/assets/img/dy.png"),
      addressInfo: {
        // 地址信息
        longitude: "", // 经度
        latitude: "", // 纬度
        province: "", // 省
        city: "", // 市
        district: "", // 区
        address: "", // 详细地址
        mapObj: undefined,
        mapObj2: undefined
      },
      showDialog: false
    }
  },
  created() {

  },
  mounted() {
    this.initBaiduMap("baidu-map-container")
  },
  methods: {
    initBaiduMap(Divid) {
      this.$nextTick(function () {
        /** 初始化地图Start */
        var mapObj = new BMap.Map(Divid); // 创建地图实例
        var point = new BMap.Point(123.198, 41.705); // 设置中心点坐标
        mapObj.centerAndZoom(point, 18); // 地图初始化，同时设置地图展示级别
        mapObj.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
        /** 初始化地图End */
        mapObj.clearOverlays(); // 移除地图上的标注
        var marker = new BMap.Marker({
          "lng": 123.197247581292,
          "lat": 41.70528234485774
        }); // 创建标注
        mapObj.addOverlay(marker); // 将标注添加到地图中
        if (Divid == 'baidu-map-container') {
          this.mapObj = mapObj;
        } else {
          mapObj.disableScrollWheelZoom();
          mapObj.addControl(new BMap.ScaleControl());
          this.mapObj2 = mapObj;
          this.mapObj2.addControl(new BMap.NavigationControl());
        }


      });
    },
    gotoMap(Divid) {
      if (Divid == 'baidu-map-container') {
        this.mapObj.centerAndZoom(new BMap.Point(123.198, 41.705), 18);
      } else {
        this.mapObj2.centerAndZoom(new BMap.Point(123.198, 41.705), 18);
      }
    },
    openDialog() {
      this.showDialog = true;
      this.initBaiduMap('baidu-map-container2')
    }
  },
}
</script>

<style scoped lang="less">
/deep/.el-dialog__body {
  padding-top: 0;
}
.fixd {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: space-Between;
  -webkit-justify-content: space-Between;
  -moz-box-pack: space-Between;
  -ms-flex-pack: space-Between;
  justify-content: space-Between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

footer {
  background: url(~@/assets/img/footer.png) no-repeat;
  background-size: 100% 100%;
  padding-top: 40px;
  padding-bottom: 20px;
  color: #fff;
  table {
    width: 100%;
    td {
      padding: 5px;
      vertical-align: top;
      font-size: 15px;
    }
    td:first-child {
      width: 100px;
    }
    td:last-child {
      padding-left: 30px;
    }
  }
  .footer-top {
    .top-con {
      width: 1000px;
      margin: 0 auto;
      .fixd();

      .footer-left {
        width: 70%;

        .site {
          .item {
            display: inline-block;
            vertical-align: top;
            width: 43%;

            .item-tit {
              font-size: 20px;
              line-height: 24px;
              color: #ffffff;
              margin-top: 17px;
              margin-bottom: 17px;
            }

            .item-con {
              .list {
                .list-tit {
                  font-size: 18px;
                  color: #fff;
                  margin-bottom: 7px;

                  span {
                    margin-left: 40px;
                  }
                }

                .list-con {
                  font-size: 14px;
                  line-height: 24px;
                  color: #fff;
                  padding-left: 43px;
                }
              }
            }
          }

          .guanzhu {
            .item-con {
              display: flex;
              justify-content: space-between;
              div {
                width: 32%;
                img {
                  width: 100%;
                }
                p {
                  margin-top: 10px;
                  font-size: 13px;
                  text-align: center;
                }
              }
            }
          }
        }
      }
      .footer-right {
        width: 27%;
      }
      .footer-top-tit {
        font-size: 26px;
        line-height: 32px;
        color: #fff;
        margin-bottom: 21px;
      }

      .erweima-list {
        color: #fff;

        p {
          margin-top: 6px;
          text-align: center;
        }

        img {
          padding: 2px;
        }
      }
    }
  }

  a {
    color: #fff;
  }
}
.footer-bottom {
  color: #fff;
  border-top: 1px solid rgba(255, 255, 2555, 0.2);
  margin: 0 auto;
  margin-top: 20px;
  padding-top: 15px;
  text-align: center;

  a {
    cursor: pointer;
  }
}
@media screen and (max-width: 1366px) {
  footer {
    padding-top: 52px;

    .footer-top {
      .top-con {
        width: 1000px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue